// eslint-disable-next-line
import util from 'util';

export function formatDateTime(dateValue, nullValue) {
  if (typeof(dateValue) === 'string') {
    let language = navigator.language ? navigator.language :"en-US";
    let d = new Date(dateValue);
    return(d.toLocaleDateString(language) + ' ' + d.toLocaleTimeString(language));
  }
  if (typeof(nullValue) !== 'undefined') {
    return(nullValue);
  }
  return('');
  
}

export function formatShortDateTime(dateValue, nullValue) {
  if (typeof(dateValue) === 'string') {
    let d = new Date(dateValue);
    let language = navigator.language ? navigator.language :"en-US";
    return(d.toLocaleDateString(language) + ' ' + d.toLocaleTimeString(undefined,{timeStyle : 'short'}));
  }
  if (typeof(nullValue) !== 'undefined') {
    return(nullValue);
  }
  return('');
  
}

export function formatDate(dateValue, nullValue) {
  if (typeof(dateValue) === 'string') {
    let d = new Date(dateValue);
    let language = navigator.language ? navigator.language :"en-US";
    return(d.toLocaleDateString(language));
  }
  if (typeof(nullValue) !== 'undefined') {
    return(nullValue);
  }
  return('');  
}

/* Do not adjust for TZ such as invoice and service periods that
  are date only */
export function formatDateNoTZ(dateValue, nullValue) {
  if (typeof(dateValue) === 'string') {
    let d = new Date(dateValue);
    return(d.toLocaleString(undefined, { timeZone: 'UTC',
                                         month: 'short', 
                                         day : 'numeric', 
                                         year: 'numeric'}));
  }
  if (typeof(nullValue) !== 'undefined') {
    return(nullValue);
  }
  return('');  
}

export function formatTime(dateValue, nullValue) {
  if (typeof(dateValue) === 'string') {
    let d = new Date(dateValue);
    return(d.toLocaleTimeString(undefined,{timeStyle : 'short'}));
  }
  if (typeof(nullValue) !== 'undefined') {
    return(nullValue);
  }
  return('');  
}

export function formatHeaderDate(dateValue, nullValue) {
  if (typeof(dateValue) === 'string') {
    let d = new Date(dateValue);
    return(String(d.getMonth()+1) + '/' + String(d.getDate()).padStart(2, '0'));
  }
  if (typeof(nullValue) !== 'undefined') {
    return(nullValue);
  }
  return('');  
}



export function formatPhoneNumber(phoneNumber) {
  if (typeof(phoneNumber) !== 'string') {
    return('');
  }
  if (phoneNumber.length === 12 && phoneNumber.startsWith('+1')) {
    return(phoneNumber.substring(2,5) + '-' +
           phoneNumber.substring(5,8) + '-' +
           phoneNumber.substring(8));
  }
  return(phoneNumber);

}

export function formatMoney(amount, currencyCode) {
  if (typeof(amount) !== 'number') {
    return('');
  }

  /* In case we're passed a negative zero which doesn't format right */
  if (amount === -0) {
    amount=0;
  }
  
  return(amount.toLocaleString(navigator.languages[0], {style:'currency', currency: currencyCode || 'USD'}));  
}


/* Display a stripe payment method object */
export function formatPaymentMethod(paymentMethod, withExpiration= true) {
  if (typeof(paymentMethod) !== 'object') {
    return('');
  }
  if (paymentMethod.type === 'card') {
    if (withExpiration) {
      return({brand: getPaymentMethodBrandOrBankName(paymentMethod) , number: getPaymentMethodLast4(paymentMethod, true), exp: paymentMethod.card.exp_month + '/' + paymentMethod.card.exp_year})
      // return(brand + ' ' + number + ' exp ' + paymentMethod.card.exp_month + '/' + paymentMethod.card.exp_year);
    } else {
      return({brand: getPaymentMethodBrandOrBankName(paymentMethod) , number: getPaymentMethodLast4(paymentMethod, true)});
      // return(brand + ' ' + number);
    }
  } else {
    //All other payment types:
    return ({brand: getPaymentMethodBrandOrBankName(paymentMethod), number: getPaymentMethodLast4(paymentMethod, true)});
  }

}

/** Get the Brand or Bank Name **/
export function getPaymentMethodBrandOrBankName(paymentMethod) {
  if (typeof(paymentMethod) !== 'object') {
    return('');
  }
  if (paymentMethod.type === 'card') {
    /* Nicer formatting for common cards */
    let brand = null;
    if (paymentMethod.card.brand === 'visa') {
      brand = 'Visa';
    }
    if (paymentMethod.card.brand === 'mastercard') {
      brand = 'MasterCard';
    }
    if (paymentMethod.card.brand === 'amex') {
      brand = 'American Express';
    }
    if (paymentMethod.card.brand === 'discover') {
      brand = 'Discover';
    }
    /* Default if its  unknown */
    if (brand == null) {
      brand = paymentMethod.card.brand[0].toUpperCase() + paymentMethod.card.brand.substring[1];
    }
    return brand;
  }
  if (paymentMethod.type === 'us_bank_account') {
    return(paymentMethod.us_bank_account.bank_name);
  }
  if (paymentMethod.type === 'bacs_debit') {
    return('BACS ' + paymentMethod.bacs_debit.sort_code);
  }
  if (paymentMethod.type === 'sepa_debit') {
    return('SEPA ' + paymentMethod.sepa_debit.bank_code);
  }
  if (typeof(paymentMethod.bank_name) === 'string') {
    return(paymentMethod.bank_name);
  }

  return('');
}

/** get the Last4 or last4 equivalent
 * padX if true, pads the necessary Xs. padX false returns the last4 alone.
 * */
export function getPaymentMethodLast4(paymentMethod, padX = true) {
  if (typeof(paymentMethod) !== 'object') {
    return('');
  }
  let number = null;
  if (paymentMethod.type === 'card') {
    /* Nicer formatting for common cards */
    number = padX ? 'xxxx xxxx xxxx ' : '';
    if (paymentMethod.card.brand === 'visa') {
      number = number + paymentMethod.card.last4;
    } else if (paymentMethod.card.brand === 'mastercard') {
      number = number + paymentMethod.card.last4;
    } else if (paymentMethod.card.brand === 'amex') {
      number = padX ? 'xxxx xxxxxx x' + paymentMethod.card.last4 : paymentMethod.card.last4;
    } else if (paymentMethod.card.brand === 'discover') {
      number = number + paymentMethod.card.last4;
    } else {
      number= 'xxxx xxxx xxxx ' + paymentMethod.card.last4;
    }
    return number;
  }
  if (paymentMethod.type === 'us_bank_account') {
    return(padX ? ' xxxxxx' + paymentMethod.us_bank_account.last4 : paymentMethod.us_bank_account.last4);
  }
  if (paymentMethod.type === 'bacs_debit') {
    return(padX ? ' xxxxx' + paymentMethod.bacs_debit.last4 : paymentMethod.bacs_debit.last4);
  }
  if (paymentMethod.type === 'sepa_debit') {
    return(padX ? ' xxxxx' + paymentMethod.sepa_debit.last4 : paymentMethod.sepa_debit.last4);
  }
  if (typeof(paymentMethod.bank_name) === 'string') {
    return(padX ? ' xxxxxx' + paymentMethod.last4 : paymentMethod.last4);
  }

  return('');
}


